<script lang="ts">
    import * as Card from "$lib/components/ui/card/index.js";
    import { t } from "svelte-i18n";
    import VieweditCustomerCard from "$src/presentation/customers/components/viewedit-customer-card.svelte";
      
    export let groupStoreId: number;
    export let patchHandler: () => void;
  
  </script>
  
  <Card.Root class="md:flex-shrink">
    <Card.Header class="pb-1">
      <Card.Title class="flex flex-row justify-between">
        <div>{$t("page.projects.detail.info-customer-title")}</div>
      </Card.Title>
    </Card.Header>
    <Card.Content>
        <VieweditCustomerCard {patchHandler} {groupStoreId} />
    </Card.Content>
  </Card.Root>
  